import { FightPlayer, Spell } from 'web/data/models'
import { CooldownResolver, DecoratingCooldownResolver } from 'web/engine/cooldowns/core-resolver'
import { GENERATED_IDS } from './generated-ids'

type SpellResolverMap = { [spellId: string]: CooldownResolver }

const { __SPELL_ID, __TALENT_ID, __MODIFIER_ID } = GENERATED_IDS

export const SPELL_RESOLVERS: SpellResolverMap = {

    [__SPELL_ID.DRUID.RESTO.TRANQ]: (spell: Spell, fightPlayer: FightPlayer) => {
        let cd = spell.cooldown

        if (spell.id === __SPELL_ID.DRUID.RESTO.TRANQ) {
            if (fightPlayer.talentIds.includes(__TALENT_ID.DRUID.RESTO.INNER_PEACE)) {
                cd = cd - 60
            }
        }

        return cd
    },

    [__SPELL_ID.DH.HAVOC.DARKNESS]: (spell: Spell, fightPlayer: FightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.DH.HAVOC.PITCH_BLACK)) {
            return spell.cooldown - 120
        }

        return spell.cooldown
    },

    [__SPELL_ID.DH.VENG.DARKNESS]: (spell: Spell, fightPlayer: FightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.DH.VENG.PITCH_BLACK)) {
            return spell.cooldown - 120
        }

        return spell.cooldown
    },

    [__SPELL_ID.DRUID.BALANCE.ROAR]: (spell: Spell, fightPlayer: FightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.DRUID.BALANCE.IMPROVED_ROAR)) {
            return spell.cooldown - 60
        }

        return spell.cooldown
    },
    [__SPELL_ID.DRUID.FERAL.ROAR]: (spell: Spell, fightPlayer: FightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.DRUID.FERAL.IMPROVED_ROAR)) {
            return spell.cooldown - 60
        }

        return spell.cooldown
    },
    [__SPELL_ID.DRUID.GUARDIAN.ROAR]: (spell: Spell, fightPlayer: FightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.DRUID.GUARDIAN.IMPROVED_ROAR)) {
            return spell.cooldown - 60
        }

        return spell.cooldown
    },
    [__SPELL_ID.DRUID.RESTO.ROAR]: (spell: Spell, fightPlayer: FightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.DRUID.RESTO.IMPROVED_ROAR)) {
            return spell.cooldown - 60
        }

        return spell.cooldown
    },

    [__SPELL_ID.DRUID.RESTO.CONVOKE]: (spell: Spell, fightPlayer: FightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.DRUID.RESTO.CEN_GUIDANCE)) {
            return spell.cooldown - 60
        }

        return spell.cooldown
    },

    [__SPELL_ID.MONK.MW.CHI_JI]: (spell: Spell, fightPlayer: FightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.MONK.MW.GIFT_OF_CELEST)) {
            return spell.cooldown - 120
        }

        return spell.cooldown
    },
    [__SPELL_ID.MONK.MW.YULON]: (spell: Spell, fightPlayer: FightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.MONK.MW.GIFT_OF_CELEST)) {
            return spell.cooldown - 120
        }

        return spell.cooldown
    },
    [__SPELL_ID.MONK.MW.COCOON]: (spell: Spell, fightPlayer: FightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.MONK.MW.CHRYS)) {
            return spell.cooldown - 45
        }

        return spell.cooldown
    },

    [__SPELL_ID.PALADIN.HOLY.AM]: (spell: Spell, fightPlayer: FightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.HOLY.UNWAVERING_SPIRIT)) {
            return spell.cooldown - 30
        }

        return spell.cooldown
    },
    [__SPELL_ID.PALADIN.HOLY.BOP]: (spell: Spell, fightPlayer: FightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.HOLY.IMP_BLESSING)) {
            return spell.cooldown - 60
        }

        return spell.cooldown
    },
    [__SPELL_ID.PALADIN.HOLY.DIV_SHIELD]: (spell: Spell, fightPlayer: FightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.HOLY.UNBREAK_SPIRIT)) {
            return Math.round(spell.cooldown * 0.70)
        }

        return spell.cooldown
    },

    [__SPELL_ID.EVOKER.PRES.REWIND]: (spell: Spell, fightPlayer: FightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.EVOKER.PRES.TEMPORAL_ARTIFICER)) {
            return spell.cooldown - 60
        }

        return spell.cooldown
    },

    [__SPELL_ID.PRIEST.SHADOW.EMBRACE]: (spell: Spell, fightPlayer: FightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.PRIEST.SHADOW.SANLAYN)) {
            return spell.cooldown - 45
        }

        return spell.cooldown
    },

    [__SPELL_ID.PALADIN.PROT.SPELLWARDING]: (spell: Spell, fightPlayer: FightPlayer) => {
        let cooldown = spell.cooldown

        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.PROT.IMP_BLESSING)) {
            cooldown = cooldown - 60
        }

        // Order matters
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.PROT.COUNSEL_2_2)) {
            cooldown = Math.round(cooldown * 0.70)
        } else if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.PROT.COUNSEL_1_2)) {
            cooldown = Math.round(cooldown * 0.85)
        }

        return cooldown
    },
    [__SPELL_ID.PALADIN.PROT.BOP]: (spell: Spell, fightPlayer: FightPlayer) => {
        let cooldown = spell.cooldown

        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.PROT.IMP_BLESSING)) {
            cooldown = cooldown - 60
        }

        // Order matters
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.PROT.COUNSEL_2_2)) {
            cooldown = Math.round(cooldown * 0.70)
        } else if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.PROT.COUNSEL_1_2)) {
            cooldown = Math.round(cooldown * 0.85)
        }

        return cooldown
    },

    [__SPELL_ID.PALADIN.PROT.DIV_SHIELD]: (spell: Spell, fightPlayer: FightPlayer) => {
        let cooldown = spell.cooldown

        // Order matters
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.PROT.COUNSEL_2_2)) {
            cooldown = Math.round(cooldown * 0.70)
        } else if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.PROT.COUNSEL_1_2)) {
            cooldown = Math.round(cooldown * 0.85)
        }

        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.PROT.UNBREAK_SPIRIT)) {
            cooldown = Math.round(cooldown * 0.70)
        }

        return cooldown
    },

    [__SPELL_ID.PALADIN.RET.BOP]: (spell: Spell, fightPlayer: FightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.RET.IMP_BLESSING)) {
            return spell.cooldown - 60
        }

        return spell.cooldown
    },
    [__SPELL_ID.PALADIN.RET.DIV_SHIELD]: (spell: Spell, fightPlayer: FightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.RET.UNBREAK_SPIRIT)) {
            return Math.round(spell.cooldown * 0.70)
        }

        return spell.cooldown
    },

    [__SPELL_ID.HUNTER.BM.TURTLE]: (spell: Spell, fightPlayer: FightPlayer) => {
        // Order matters
        if (fightPlayer.talentIds.includes(__TALENT_ID.HUNTER.BM.BORN_TO_BE_WILD_2_2)) {
            return Math.round(spell.cooldown * 0.8)
        } else if (fightPlayer.talentIds.includes(__TALENT_ID.HUNTER.BM.BORN_TO_BE_WILD_1_2)) {
            return Math.round(spell.cooldown * 0.9)
        }

        return spell.cooldown
    },
    [__SPELL_ID.HUNTER.SV.TURTLE]: (spell: Spell, fightPlayer: FightPlayer) => {
        // Order matters
        if (fightPlayer.talentIds.includes(__TALENT_ID.HUNTER.SV.BORN_TO_BE_WILD_2_2)) {
            return Math.round(spell.cooldown * 0.8)
        } else if (fightPlayer.talentIds.includes(__TALENT_ID.HUNTER.SV.BORN_TO_BE_WILD_1_2)) {
            return Math.round(spell.cooldown * 0.9)
        }

        return spell.cooldown
    },
    [__SPELL_ID.HUNTER.MM.TURTLE]: (spell: Spell, fightPlayer: FightPlayer) => {
        // Order matters
        if (fightPlayer.talentIds.includes(__TALENT_ID.HUNTER.MM.BORN_TO_BE_WILD_2_2)) {
            return Math.round(spell.cooldown * 0.8)
        } else if (fightPlayer.talentIds.includes(__TALENT_ID.HUNTER.MM.BORN_TO_BE_WILD_1_2)) {
            return Math.round(spell.cooldown * 0.9)
        }

        return spell.cooldown
    },

}

export const GENERIC_RESOLVERS: { [key: string]: DecoratingCooldownResolver } = {

    // [__MODIFIER_ID.PITCH_BLACK]: (spell: Spell, _fightPlayer: FightPlayer, cooldown: number) => {

    //     if ([__SPELL_ID.DH.VENG.DARK, __SPELL_ID.DH.HAVOC.DARK].includes(spell.id) === false) {
    //         return cooldown
    //     }

    //     return cooldown - 120
    // },

    /**
     * Not used, but keeping it as a reference.
     *
     * NOTICE: Trust nothing in here, I have no idea what any of this
     * is supposed to do.
     */
    VOP_R3: (spell: Spell, fightPlayer: FightPlayer, cooldown: number) => {
        const spellIsAffected = spell.affectedByModifierIds
            .includes("__MODIFIER_ID.ESSENCE_VOP")

        const playerHasMod = fightPlayer.modifierIds
            .includes("__MODIFIER_ID.ESSENCE_VOP")

        const applyMod = spellIsAffected && playerHasMod

        if (applyMod === false) {
            return cooldown
        }

        // VOP R3 takes off roughly 77% (23% reduction)
        return Math.ceil(cooldown * 0.77)
    }

}
